import { useQuery } from '@tanstack/react-query';

import { useLocale } from 'hooks/useLocale';
import { StaleTime } from 'queries/types';

import { loyaltyTiersQuery } from './queries';

export const useLoyaltyTiers = () => {
  const { locale } = useLocale();

  const { data, isPending } = useQuery({
    ...loyaltyTiersQuery({ locale }),
    staleTime: StaleTime.FOREVER,
    retry: false,
  });

  return {
    loyaltyTiers: data?.loyaltyTiers ?? [],
    isLoading: isPending,
  };
};
